<div class="flashes">
    <div class="flash" [ngClass]="'flash-' + flash.type" *ngFor="let flash of flashes$ | async">
        {{ flash.message | translate }}
        <a (click)="onClose(flash.id)" class="flash-close">&times;</a>
    </div>
</div>
